import React, {useEffect, useState, useRef} from 'react';
import './App.css';
import {BrowserRouter, Routes, Route, Link} from "react-router-dom";
import Main from './pages/Main';
import Photo from './pages/Photo';
import Art from './pages/Art';
import Profile from './pages/profile';
import Social from './pages/social';
import NotFound from './pages/NotFound';
import MountainCom from './component/MountainCom';
import SkyCom from './component/SkyCom';

function App(props) {
  const contentBox = useRef(null);//스크롤 대상엘리먼트
  const [position, setPosition] = useState(0);//스크롤 값
  const [count,setCount] = useState({page:'main'});//페이지정보
  const thisPageState = (pageNum) => {setCount({page:pageNum, conBox : contentBox})}
  const mianControl = ["kLayout",("type_"+count.page), "",""];//[기본,페이지,스크롤]
  mianControl[2] = position > 10 ? "scroll" : "";
  mianControl[3] = position > 389 ? "fixed" : "";
  function onScroll() {
    setPosition(contentBox.current.scrollTop);
  }
  function menuClick(){
    contentBox.current.scrollTo({top:0, behavior: 'auto'});
  }
  useEffect(() => {
    contentBox.current.addEventListener("scroll", onScroll);
     return () => {
      contentBox.current.removeEventListener("scroll", onScroll); 
    };

  } );
  return(
    <BrowserRouter>
      <div className={mianControl.join(" ")}>
        <SkyCom />
        <MountainCom />
        <h1 className="mainTitle">
          <span>Light and Space</span>
          <strong>Dreaming in Simulacre</strong>
        </h1>
        <nav className="gnbMenu">
          <h1><Link to="/"><img src="../../logo.svg" alt="" /></Link></h1>
          <Link to="/photo/main" onClick={() => menuClick()} >Photo</Link>
          <Link to="/art/2017" onClick={() => menuClick()} >Art</Link>
          <Link to="/profile/main" onClick={() => menuClick()} >Profile</Link>
          <Link to="/social/main" onClick={() => menuClick()} >Social</Link>
        </nav>
        <div className="contentBox" ref={contentBox}>
          <Routes>
            <Route path="/" exact={true} element={<Main pageN={count} pageF={thisPageState} />} />
            <Route path="/photo/:pageNum" element={<Photo pageN={count} pageF={thisPageState} />} />
            <Route path="/art/:pageNum" element={<Art pageN={count} pageF={thisPageState} pageScroll={position} />} />
            <Route path="/profile/:pageNum" element={<Profile pageN={count} pageF={thisPageState} />} />
            <Route path="/social/:pageNum" element={<Social pageN={count} pageF={thisPageState} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <div className="copyBox">
        <p><img src="../../name.svg" alt="Kang, deok won" /></p>
        ⓒ 2023. Kang, deokwon All pictures cannot be copied without permission. 
        </div>
      </div>
    </BrowserRouter>
  )
}

export default App;
